module.exports = __webpack_public_path__ + "img/TRACTOR_RHD.c79c1af4.jpg";